import { BaseTag } from 'mixs/base/base_mixin';
import TodaysDeliveriesController from './deliveries/controller';
import { Scopes } from 'apps/scopes';
import {
  DELIVERY_SELECT_START_DATE,
  DELIVERY_CLICK_DOWNLOAD,
  DELIVERY_CLICK_LETTER,
  DELIVERY_CLICK_SAVE,
  DELIVERY_CLICK_LABELS
} from 'apps/events';

class TodaysDeliveries extends BaseTag {
  controller: TodaysDeliveriesController;
  init(){
    super.init();
    this.watch();
    this.controller = new TodaysDeliveriesController(this)
  }
  onClickDownloadForSagawa(){
    var customEvent = new CustomEvent(DELIVERY_CLICK_DOWNLOAD, {detail: 'yamato'});
    document.dispatchEvent(customEvent);
  }
  onClickSave(){
    var customEvent = new CustomEvent(DELIVERY_CLICK_SAVE);
    document.dispatchEvent(customEvent);
  }
  onClickLetter(){
    var customEvent = new CustomEvent(DELIVERY_CLICK_LETTER);
    document.dispatchEvent(customEvent);
  }
  onClickLabels(){
    var customEvent = new CustomEvent(DELIVERY_CLICK_LABELS);
    document.dispatchEvent(customEvent);
  }
  hasDifferentTodaysValue(){
    const ids = this.opts.task_ids
    for(let i=0; i < ids.length; i++){
      const id = ids[i];
      const taskData = Scopes.getTaskData(id);
      const deliveryData = Scopes.getDeliveryRecordData(taskData.taskable_id);
      const deliverySumData = Scopes.getDeliveryRecordSumData(taskData.taskable_id);
      if(deliveryData.value.toString() != deliverySumData.memo_theday.toString()){ return true; }
    }
    return false;
  }
}

riot.mixin('todays.deliveries', TodaysDeliveries as riot.TagMixin)
